"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FocusManager = void 0;
var _tabbable = require("tabbable");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isFunction = require("./isFunction");
/* eslint-disable class-methods-use-this */

class FocusManager {
  constructor({
    trapNode,
    getTabbableNodes,
    delay = 0,
    nextKeyCode,
    previousKeyCode,
    firstFocusIndex,
    suppressInitialAttachment,
    stopKeyPressPropagation,
    trapWithTabbing,
    onlyContainedEvents,
    useHomeAndEndKeys,
    skipEvent
  }) {
    var _a;
    this.detach = () => {
      document.removeEventListener('keydown', this.keyHandler);
    };
    this.isFocusContained = () => this.container && this.container.contains(document.activeElement) || this.tabbableNodes.length && this.tabbableNodes.some(node => node.contains(document.activeElement));
    this.updateTabbableNodes = () => {
      this.tabbableNodes = this.getTabbableNodes();
    };
    this.getIsPreviousKey = event => {
      const isShiftTab = event.keyCode === _keycode.default.codes.tab && event.shiftKey;
      if (typeof this.previousKeyCode === 'undefined') {
        return isShiftTab;
      }
      const isPreviousKey = event.keyCode === this.previousKeyCode;
      return this.trapWithTabbing ? isShiftTab || isPreviousKey : isPreviousKey;
    };
    this.getIsNextKey = event => {
      const isTabKey = event.keyCode === _keycode.default.codes.tab;
      if (typeof this.nextKeyCode === 'undefined') {
        return isTabKey;
      }
      const isNextKey = event.keyCode === this.nextKeyCode;
      return this.trapWithTabbing ? isTabKey || isNextKey : isNextKey;
    };
    this.keyHandler = e => {
      if (!document.body.contains(this.container)) {
        document.removeEventListener('keydown', this.keyHandler);
        return;
      }
      if (this.onlyContainedEvents && !this.container.contains(e.target)) {
        return;
      }
      if ((0, _isFunction.isFunction)(this.skipEvent) && this.skipEvent(e)) {
        return;
      }
      const isPreviousKey = this.getIsPreviousKey(e);
      const isNextKey = this.getIsNextKey(e);
      const isHomeKey = (0, _keycode.default)(e) === 'home';
      const isEndKey = (0, _keycode.default)(e) === 'end';
      if (isPreviousKey || isNextKey || this.useHomeAndEndKeys && (isHomeKey || isEndKey)) {
        e.preventDefault();
        if (this.stopKeyPressPropagation) {
          e.stopPropagation();
        }
        this.updateTabbableNodes();
        if (!this.isFocusContained()) {
          this.tryFocus(this.tabbableNodes[0], 0);
        }
        const currentIndex = this.tabbableNodes.indexOf(e.target);
        const lastNode = this.tabbableNodes[this.tabbableNodes.length - 1];
        const firstNode = this.tabbableNodes[0];
        if (isPreviousKey) {
          if (this.tabbableNodes[currentIndex] === firstNode) {
            this.tryFocus(lastNode, this.tabbableNodes.length - 1);
          } else if (currentIndex < 0) {
            this.tryFocus(firstNode, 0);
          } else {
            this.tryFocus(this.tabbableNodes[currentIndex - 1], currentIndex - 1);
          }
        } else if (isNextKey) {
          if (this.tabbableNodes[currentIndex] === lastNode) {
            this.tryFocus(firstNode, 0);
          } else {
            this.tryFocus(this.tabbableNodes[currentIndex + 1], currentIndex + 1);
          }
        } else if (isHomeKey) {
          this.tryFocus(firstNode, 0);
        } else if (isEndKey) {
          this.tryFocus(lastNode, this.tabbableNodes.length - 1);
        }
      }
    };
    this.tryFocus = (node, index) => {
      if (node) {
        const posX = window.pageXOffset;
        const posY = window.pageYOffset;
        node.focus();
        window.scrollTo(posX, posY);
        if (typeof index !== 'undefined') {
          this.focusedIndex = index;
        }
      }
    };
    this.container = trapNode;
    this.nextKeyCode = nextKeyCode;
    this.previousKeyCode = previousKeyCode;
    this.trapWithTabbing = trapWithTabbing;
    this.stopKeyPressPropagation = !!stopKeyPressPropagation;
    this.onlyContainedEvents = !!onlyContainedEvents;
    this.useHomeAndEndKeys = !!useHomeAndEndKeys;
    this.skipEvent = skipEvent;
    this.getTabbableNodes = (0, _isFunction.isFunction)(getTabbableNodes) ? getTabbableNodes : () => (0, _tabbable.tabbable)(this.container);
    this.updateTabbableNodes();
    document.addEventListener('keydown', this.keyHandler);
    if (!suppressInitialAttachment && ((_a = this.tabbableNodes) === null || _a === void 0 ? void 0 : _a.length)) {
      setTimeout(() => {
        // because this.tryFocus causes auto-scrolling to the focus target,
        // we should allow a delay before it is called.
        // This will prevent the scroll from bouncing around the viewport if
        // the target receives focus and then changes positions.
        // This bug is observed in Popovers on IE11
        // https://github.concur.com/coreui/nui-widgets/issues/912
        if ((firstFocusIndex !== null && firstFocusIndex !== void 0 ? firstFocusIndex : -1) > -1) {
          this.tryFocus(this.tabbableNodes[firstFocusIndex], firstFocusIndex);
        } else {
          this.tryFocus(this.tabbableNodes[0], 0);
        }
      }, delay);
    }
  }
}
exports.FocusManager = exports.default = FocusManager;